import React from 'react';
import {getImageUrl} from '../../api/iposApi';

const Branch = ({branchInfo, openBranch}) => {
  return (
    <div
      className={ 'branch-info' }
      onClick={ () => {
        openBranch(branchInfo.branch_guid_code);
      } }
    >
      <div className={ 'branch-logo' }>
        <img
          src={ getImageUrl(`${branchInfo.branch_guid_code}_logo.jpg`, true) }
          className="img-responsive"
          alt="iPos Web Delivery"
        />
      </div>
      <div className={ 'branch-details' }>
        <div className={ 'branch-name' }>{branchInfo.branch_name}</div>
        <div className={ 'branch-address' }>{branchInfo.address_txt}</div>
      </div>

    </div>
  );
};

export default Branch;
